/*
 * @FilePath     : /es-package/packages/es-mpx-usex/lib/plugin.js
 * @Author       : LiYang
 * @Date         : 2022-01-15 15:16:14
 * @LastEditTime: 2023-08-25 00:44:21
 * @LastEditors: liuziwei
 * @Description  : 
 */
import { mpx } from '@didi/es-mpx-creator'
import { parseQuery } from '@didi/es-mpx-shared'
import {logout} from '../login/login'
import relog from './relog' 
import store from './store'
import { urlsWithoutToken } from '@/config/interceptors/config'
import { is } from '@didi/webx-js'

// 10505 请求后端ticket过期时返回的错误
const expireds = ['10505']
// 是否正在刷新的标记
let isRefreshing = false
//重试队列
let requests = []
let queue = [];

const getQuery = (url) => {
  const idx = url.indexOf('?')
  return idx > -1 ? url.substr(idx+1, url.length) : ''
}

const getPath = (url) => {
  const idx = url.indexOf('?')
  return idx > -1 ? url.substr(0, idx) : url

}

export const closeMask= () => {
  let mask = document.getElementById('windowMask');
  if (mask) {
   mask.style.display = 'none';
  }
}

const service = (config, income) => {
  const { data, params, url } = config;
  const urlQuery = getQuery(url);
  let query = parseQuery(data || params || urlQuery);
  ['sig', 'token', 'phone', 'wsgsig'].forEach(key => {
    delete query[key]
  });

  if (config.data) {
    config.data = {...query, ...income}
  }

  if (config.params || urlQuery) {
    config.params = {...query, ...income}
  }

  config.url = getPath(config.url)
  return mpx.$http(config)

}

export const response = (res) => {
  const {data: { errcode }, requestConfig } = res || {}

  // 登录过期
  if (expireds.includes(errcode)) {
    if (!isRefreshing) {
      isRefreshing = true
      closeMask()
      return logout().then(() => relog(({token, phone}) => {
        const res = {token, phone}
        requests.forEach((cb) => cb(res))
        requests = []
        isRefreshing = false
        flush()
        return service(requestConfig, res)
      }))
    } else {
      return new Promise(resolve => {
        requests.push((params) => {
          resolve(service(requestConfig, params))
        })
      })
    }
  }

  return Promise.resolve(res);
}

// 如果登录过期重试中，就等待token刷新暂不发出请求
export const request = (config) => {
  console.log("正在刷新队列或者是正在登录所有请求进入队列等待",(isRefreshing || !store.state.loged) && !config.passed, isRefreshing, !store.state.loged)
  const { url } = config 
  const isNoNeedTokenRequest = urlsWithoutToken?.some(item => url?.indexOf(item) > 0) && (is('alipay') || is('alimp'))
  const passed = config.passed || isNoNeedTokenRequest
  if (passed) {
    return Promise.resolve(config)
  }
   // 如果是正在刷新队列或是正在登录，所有请求进入队列等待
   if ((isRefreshing || !store.state.loged) && !config.passed) {
    return new Promise(resolve => {
      queue.push(() => {
        resolve(config)
      })
    })
  } 
  return Promise.resolve(config)
}

export const flush = () => {
  if (queue.length) {
    queue.forEach(req => req())
    queue = []
  }
}